import {Component, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ProfileService} from '../profile.service';
import {
    mapToDocumentModifications,
    mapToMember,
    mapToProfileImageModification,
    ProfileFormService
} from '../profile-form.service';
import {UntypedFormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {ScreenService} from 'src/app/ui-library/screen.service';

@Component({
    selector: 'app-setup-recipient-offer',
    templateUrl: './setup-recipient-offer.component.html',
    styleUrls: ['./setup-recipient-offer.component.scss'],
    standalone: false
})
export class SetupRecipientOfferComponent implements OnInit, OnDestroy {
    readonly form: UntypedFormGroup;
    readonly step3: UntypedFormGroup;
    isTrapActive = false;
    isLoading$ = new BehaviorSubject<boolean>(false);

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private renderer: Renderer2,
        private screenService: ScreenService,
        private profileService: ProfileService,
        formService: ProfileFormService) {
        this.isTrapActive = this.screenService.isMobileScreen();
        this.form = formService.createRecipient();
        this.step3 = this.form.get('step3') as UntypedFormGroup;
    }

    get navigateState() {
        return {
            onboardingForm: this.form.value
        };
    }

    ngOnInit(): void {
        // add class to body to prevent scrolling in the background on mobile screen
        this.renderer.addClass(document.body, 'full-screen');

        const formState = window.history.state?.onboardingForm;
        if (formState) {
            this.form.setValue(formState);
        } else {
            this.router.navigate(['../recipient-profile'], {
                relativeTo: this.route
            });
        }
    }

    ngOnDestroy(): void {
        this.renderer.removeClass(document.body, 'full-screen');
    }

    back(): void {
        this.router.navigate(['../recipient-profile-details'], {
            relativeTo: this.route,
            state: this.navigateState
        });
    }

    submitForm() {
        if (this.form.valid) {
            this.isLoading$.next(true);
            const member = mapToMember(null, 'Job', this.form);
            const profileImageMod = mapToProfileImageModification(this.form);
            const docMods = mapToDocumentModifications(this.form.value.step2.documents);
            this.profileService.registerRecipient(member, profileImageMod, docMods).then(
                () => {
                    this.isLoading$.next(false);
                    console.log('Successfully registered');
                    this.router.navigate(['/marketplace'], {relativeTo: this.route, state: {showWelcome: true}});
                },
                (err) => {
                    this.isLoading$.next(false);
                    console.log('Registration failed', err);
                }
            );
        } else {
            this.step3.markAllAsTouched();
        }
    }
}
